import "regenerator-runtime/runtime.js";
import { $ } from 'donot';
import { pagination } from './pagination.js';
import { previewer } from './previewer.js';
import { searchform } from './searchform.js';
import { strap } from './util.js';
import mediumZoom from 'medium-zoom';

// https://developer.matomo.org/guides/spa-tracking
// For Vue components, like the previewer
function addHashTracking() {
    // Don't do any tracking if the tracker is not loaded
    if (!('_paq' in window)) {
        return;
    }

    window.addEventListener('hashchange', () => {
        const hash = window.location.hash.slice(1);
        _paq.push(['setCustomUrl', `/${hash}`]);
        _paq.push(['setDocumentTitle', 'Previewer']);
        _paq.push(['trackPageView']);
    });
}

function addSupportClasses() {
    const type = 'ontouchend' in window ? 'has-touch' : 'has-mouse';
    $("html").classList.add(type);
    $("html").classList.remove('no-js');
    $("html").classList.add('has-js');
}

function main() {
    addHashTracking();
    addSupportClasses();

    strap('[data-zoomable], [class^="wp-image-"]', (el) => {
        mediumZoom(el, { "background" : "black" });
    });
    strap(".image-grid", previewer);
    strap("#searchform", searchform);
    strap(".pagination", pagination);
}

main();